import React from "react";
import { DonutChartSegment } from "../types";

interface DonutChartProps {
  segments: DonutChartSegment[];
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export const DonutChart: React.FC<DonutChartProps> = ({
  segments,
  size = 64,
  strokeWidth = 11,
  className = "",
}) => {
  const center = size / 2;
  const radius = center - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;

  const total = segments.reduce((sum, seg) => sum + Math.max(0, seg.value), 0);

  if (total <= 0) {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className={className}
      >
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#F2F4F7"
          strokeWidth={strokeWidth}
        />
      </svg>
    );
  }

  let accumulatedLength = 0;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={`-rotate-90 transform ${className}`}
    >
      {/* Background track */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="#F4F5F9"
        strokeWidth={strokeWidth}
      />
      {segments.map((seg, idx) => {
        if (seg.value <= 0) return null;
        const segmentLength = (seg.value / total) * circumference;
        const strokeDashoffset = -accumulatedLength;
        accumulatedLength += segmentLength;

        return (
          <circle
            key={idx}
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={seg.color}
            strokeWidth={strokeWidth}
            strokeDasharray={`${segmentLength} ${circumference - segmentLength}`}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="butt"
          />
        );
      })}
    </svg>
  );
};
